import { createContext, useContext, useState } from "react";

interface UnsavedChangesContextType {
    hasUnsavedChanges: boolean;
    setHasUnsavedChanges: (value: boolean) => void;
}

const UnsavedChangesContext = createContext<UnsavedChangesContextType>({
    hasUnsavedChanges: false,
    setHasUnsavedChanges: () => {},
});

export const UnsavedChangesProvider = ({ children }: { children: React.ReactNode }) => {
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

    return (
        <UnsavedChangesContext.Provider value={{ hasUnsavedChanges, setHasUnsavedChanges }}>
            {children}
        </UnsavedChangesContext.Provider>
    );
};

export const useUnsavedChanges = () => useContext(UnsavedChangesContext);
